import { render, staticRenderFns } from "./bridgeImg.vue?vue&type=template&id=0610d161"
import script from "./bridgeImg.vue?vue&type=script&lang=js"
export * from "./bridgeImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports